import { SVGProps } from 'react'

export const FederationIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.0007 27.1C18.6516 27.1 20.8007 24.951 20.8007 22.3C20.8007 19.649 18.6516 17.5 16.0007 17.5C13.3497 17.5 11.2007 19.649 11.2007 22.3C11.2007 24.951 13.3497 27.1 16.0007 27.1ZM16.0007 28.6C19.4801 28.6 22.3007 25.7794 22.3007 22.3C22.3007 18.8206 19.4801 16 16.0007 16C12.5213 16 9.70068 18.8206 9.70068 22.3C9.70068 25.7794 12.5213 28.6 16.0007 28.6Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.4248 7.07492C6.25323 7.07492 6.9248 6.40334 6.9248 5.57492C6.9248 4.74649 6.25323 4.07492 5.4248 4.07492C4.59638 4.07492 3.9248 4.74649 3.9248 5.57492C3.9248 6.40334 4.59638 7.07492 5.4248 7.07492ZM5.4248 8.19991C6.87455 8.19991 8.0498 7.02466 8.0498 5.57492C8.0498 4.12517 6.87455 2.94992 5.4248 2.94992C3.97506 2.94992 2.7998 4.12517 2.7998 5.57492C2.7998 7.02466 3.97506 8.19991 5.4248 8.19991Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.0005 7.07499C16.8289 7.07499 17.5005 6.40342 17.5005 5.57499C17.5005 4.74657 16.8289 4.075 16.0005 4.075C15.1721 4.075 14.5005 4.74657 14.5005 5.57499C14.5005 6.40342 15.1721 7.07499 16.0005 7.07499ZM16.0005 8.19999C17.4502 8.19999 18.6255 7.02474 18.6255 5.57499C18.6255 4.12525 17.4502 2.95 16.0005 2.95C14.5507 2.95 13.3755 4.12525 13.3755 5.57499C13.3755 7.02474 14.5507 8.19999 16.0005 8.19999Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.4248 7.07492C27.2532 7.07492 27.9248 6.40334 27.9248 5.57492C27.9248 4.74649 27.2532 4.07492 26.4248 4.07492C25.5964 4.07492 24.9248 4.74649 24.9248 5.57492C24.9248 6.40334 25.5964 7.07492 26.4248 7.07492ZM26.4248 8.19991C27.8745 8.19991 29.0498 7.02466 29.0498 5.57492C29.0498 4.12517 27.8745 2.94992 26.4248 2.94992C24.9751 2.94992 23.7998 4.12517 23.7998 5.57492C23.7998 7.02466 24.9751 8.19991 26.4248 8.19991Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.4385 7.18002V16.6H16.5635V7.18002H15.4385Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.938 7.18011V8.80001C4.938 10.7675 6.53298 12.3625 8.5005 12.3625H16.0005V11.2375H8.5005C7.1543 11.2375 6.063 10.1462 6.063 8.80001V7.18011H4.938Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.063 7.18011V8.80001C27.063 10.7675 25.468 12.3625 23.5005 12.3625H16.0005V11.2375H23.5005C24.8467 11.2375 25.938 10.1462 25.938 8.80001V7.18011H27.063Z"
      fill="currentColor"
    />
  </svg>
)
